import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import Home from "./pages/Home";
import Method from "./pages/Method";
import School from "./pages/School";
import Founder from "./pages/Founder";
import Coaching from "./pages/Coaching";
import Pathways from "./pages/Pathways";
import Testimonials from "./pages/Testimonials";
import Apply from "./pages/Apply";
import InstagramContent from "./pages/InstagramContent";
import BrandLogos from "./pages/BrandLogos";
import ReelsStudio from "./pages/ReelsStudio";
import TestimonialReels from "./pages/TestimonialReels";
import SynthReviews from "./pages/SynthReviews";
import ChildrenCoaching from "./pages/ChildrenCoaching";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/method" element={<Method />} />
          <Route path="/school" element={<School />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/children-coaching" element={<ChildrenCoaching />} />
          <Route path="/pathways" element={<Pathways />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/content" element={<InstagramContent />} />
          <Route path="/brand" element={<BrandLogos />} />
          <Route path="/reels" element={<ReelsStudio />} />
          <Route path="/testimonial-reels" element={<TestimonialReels />} />
          <Route path="/synth-reviews" element={<SynthReviews />} />
        </Routes>
        <Footer />
        <WhatsAppWidget />
      </BrowserRouter>
    </div>
  );
}

export default App;
